import { UpdateRoleComponent } from './update-role/update-role.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { RolesComponent } from './roles.component';
import { MainLayoutComponent } from '../../components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const RolesRoutes: Routes = [
    {
        path: 'admin/roles',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'ADMIN_PANEL',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: RolesComponent },
            { path: 'create', component: CreateRoleComponent },
            { path: ':id/update', component: UpdateRoleComponent }
        ]
    }
];
